/* This file was auto generated by "icon-optimizer" */

import { DEV } from 'esm-env';
import createSvgIcon from '../createSvgIcon';
export default createSvgIcon(
  'M5 20h14c.5 0 1-.5 1-1v-8H4v8c0 .5.4 1 1 1ZM6 6H5a1 1 0 0 0-1 1v1c0 .5.4 1 1 1h14c.5 0 1-.5 1-1V7c0-.6-.5-1-1-1h-1v1h-2V6H8v1H6V6Zm12-2h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V2h2v1c0 .5.4 1 1 1h6c.5 0 1-.5 1-1V2h2v2Zm-2.5 11h2c.2 0 .5.2.5.6v1.8c0 .4-.3.6-.6.6h-1.9a.6.6 0 0 1-.5-.6v-1.8c0-.4.2-.6.5-.6Z',
  DEV ? 'CalendarIcon' : '',
  '',
  false,
);
